import { useEffect } from "react";

type Params = {
  open: boolean;
  filteredPairs: any[];
  activeIndex: number;
  setActiveIndex: React.Dispatch<React.SetStateAction<number>>;
  onSelect: (symbol: string) => void;
  onClose: () => void;
};

export const usePairKeyboard = ({
  open,
  filteredPairs,
  activeIndex,
  setActiveIndex,
  onSelect,
  onClose,
}: Params) => {
  useEffect(() => {
    const handleKey = (e: KeyboardEvent) => {
      if (!open) return;

      if (e.key === "Escape") {
        onClose();
        return;
      }

      if (e.key === "ArrowDown") {
        e.preventDefault();
        setActiveIndex((prev) =>
          prev < filteredPairs.length - 1 ? prev + 1 : 0,
        );
      }

      if (e.key === "ArrowUp") {
        e.preventDefault();
        setActiveIndex((prev) =>
          prev > 0 ? prev - 1 : filteredPairs.length - 1,
        );
      }

      if (e.key === "Enter") {
        if (filteredPairs[activeIndex]) {
          onSelect(filteredPairs[activeIndex].symbol);
        }
      }
    };

    document.addEventListener("keydown", handleKey);
    return () => document.removeEventListener("keydown", handleKey);
  }, [open, filteredPairs, activeIndex]);
};
